import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { BiArrowFromLeft, BiLock } from "react-icons/bi";
import { FiPower } from "react-icons/fi";
import "react-tabs/style/react-tabs.css";
import "../landing-page.css";
import axios from "axios";
import { TOKEN_INVALIDATE_URL } from "../Services/APIurls";
import { LOGIN_DOMAIN } from "../Services/Configuration";
import { ClearLocalStorage } from "../Components/utils/commonFunctions";
import Swal from "sweetalert2";
import { AiOutlineHome } from "react-icons/ai";
import axiosTokenService from "../Services/axiosTokenService";
var createGuest = require("cross-domain-storage/guest");
import { useHistory } from "react-router-dom";
const Dashboard = () => {
  const history = useHistory();
  let user = localStorage.getItem("username");

  // if (user === "" || user === undefined || user === null) {
  //   Swal.fire({
  //     text: "Session Expired",
  //     icon: "success",
  //     confirmButtonText: "Ok",
  //     confirmButtonClass: "swal-button--confirm",
  //   }).then(function () {
  //     window.location.href = LOGIN_DOMAIN;
  //   });
  // } else {
  // }

  function handleChangePassword() {
    history.push("/ChangePassword.do");
  }
  function handleLogOut() {
    Swal.fire({
      text: "Are You Sure Want to Sign Out?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axiosTokenService.post(TOKEN_INVALIDATE_URL).then((res) => {
          if (res !== "" && res !== undefined && res !== null) {
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            localStorage.removeItem("user");
            localStorage.clear();
            ClearLocalStorage();
            history.go(0);
          }
        });
      }
    });
  }

  return (
    <div className="Dashboard">
      <OFMSUI.Container fluid>
        <OFMSUI.Row>
          <OFMSUI.Navbar collapseOnSelect expand="lg" fixed="top" className="HERB-Top-Nav" style={{ posistion: "fixed", top: "0px" }} >
            <OFMSUI.Navbar.Brand href="Dashboardheader"> <img src="img/APSHCL.png" style={{ marginLeft: "5px" }} height="45" className="d-inline-block align-top" alt="APSHCL" /> </OFMSUI.Navbar.Brand>
            <OFMSUI.Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <OFMSUI.Navbar.Collapse id="responsive-navbar-nav">
              <OFMSUI.Nav className="me-auto"></OFMSUI.Nav> <OFMSUI.Nav> <a href="Dashboardheader"> <AiOutlineHome style={{ fontSize: "23px", marginRight: "10px", cursor: "pointer", }} title="HOME" /> </a> </OFMSUI.Nav>
              <OFMSUI.Nav> 
                <OFMSUI.NavDropdown className="header-dropdown-setting" title={ <b> <span> {"Welcome:"} {user} </span>{" "} &nbsp; </b> } id="basic-nav-dropdown" > 
                {/* <OFMSUI.NavDropdown.Item onClick={()=>handleChangePassword()}> <a href="ChangePassword.do" style={{ color: "#212529" }}> <FiPower /> Change Password </a> 
                </OFMSUI.NavDropdown.Item>  */}
                
                <OFMSUI.NavDropdown.Item onClick={handleLogOut}> <FiPower size={15} onClick={handleLogOut} /> Logout </OFMSUI.NavDropdown.Item> 
                
                </OFMSUI.NavDropdown> </OFMSUI.Nav>
            </OFMSUI.Navbar.Collapse>
          </OFMSUI.Navbar>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <div className="main_section"></div>
    </div>
  );
};

export default Dashboard;
